import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'formly-form, [appFormlyCaretAtEnd]'
})
export class FormlyCaretAtEndDirective {
  @HostListener('focusin', ['$event'])
  onFocusIn(event: FocusEvent) {
    const focusTarget = this.resolveFocusTarget(event);
    if (!focusTarget) {
      return;
    }

    void this.placeCaretAtEnd(focusTarget);
    setTimeout(() => {
      void this.placeCaretAtEnd(focusTarget);
    }, 0);
  }

  private resolveFocusTarget(event: FocusEvent): HTMLElement | null {
    const path = (event.composedPath?.() || []) as EventTarget[];
    for (const entry of path) {
      if (entry instanceof HTMLInputElement) {
        return entry;
      }
      if (entry instanceof HTMLElement && entry.tagName?.toLowerCase() === 'ion-input') {
        return entry;
      }
    }

    const target = event.target;
    if (target instanceof HTMLInputElement) {
      return target;
    }

    if (target instanceof HTMLElement && target.tagName?.toLowerCase() === 'ion-input') {
      return target;
    }

    return null;
  }

  private async placeCaretAtEnd(target: HTMLElement) {
    if (target instanceof HTMLInputElement) {
      if (!this.isTextInput(target.type)) {
        return;
      }
      this.setCaret(target);
      return;
    }

    if (target.tagName?.toLowerCase() !== 'ion-input') {
      return;
    }

    const ionInputHost = target as HTMLElement & { getInputElement?: () => Promise<HTMLInputElement> };
    const innerInput = ionInputHost.getInputElement
      ? await ionInputHost.getInputElement()
      : (ionInputHost.shadowRoot?.querySelector('input') as HTMLInputElement | null);

    if (!innerInput || !this.isTextInput(innerInput.type)) {
      return;
    }

    this.setCaret(innerInput);
  }

  private isTextInput(type: string) {
    return !type || type === 'text' || type === 'search' || type === 'email' || type === 'url' || type === 'tel';
  }

  private setCaret(inputElement: HTMLInputElement) {
    if (inputElement.readOnly || inputElement.disabled) {
      return;
    }

    const valueLength = inputElement.value?.length || 0;
    inputElement.setSelectionRange(valueLength, valueLength);
  }
}
